module.exports = __webpack_public_path__ + "img/receipt30.ca588426.svg";